export default __webpack_public_path__ + "static/media/12-VestjyskBank.3cde1f06.png";